// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "xlsx" + "." + "09443c88" + ".chunk.js";
};